import Scanner from './Scanner';
import './Scanner.scss';

export default Scanner;
